const trains = {
  train: "Tren", // translated
  trains: "Trenes", // translated
  fairConditions: "Condiciones justas", // translated
  to: "a", // translated
  earlier: "Más temprano", // translated
  later: "Más tarde", // translated
  adults: "Adultos", // translated
  child: "Niño", // translated
  senior: "Sénior", // translated
  seniors: "personas mayores", // translated
  price: "Precio", // translated
  for: "para", // translated
  total: "Total", // translated
  selected: "Seleccionado", // translated
  prebook: "Reservar de antemano", // translated
  book: "Libro", // translated
  payment: "Pago", // translated
  return: "Devolver", // translated
  passengers: "Pasajeros", // translated
  delivery: "Entrega", // translated
  summary: "Resumen", // translated
  checkout: "Verificar", // translated
  trainToastCorrectFillForm: "Por favor complete correctamente todos los campos.", // translated
  fareConditions: "Condiciones de la tarifa", // translated
  travelInfo: "Información de viaje", // translated
  remarks: "Comentarios del cliente", // translated
  noServices: "Sin servicios", // translated
  timesAndSeats: "Horarios y asientos", // translated
  mobileTicket: "billete móvil", // translated
  stationTicket: "Recoger en la estación", // translated
  homeTicket: "Imprimelo en casa", // translated
  countryCode: "Código de país", // translated
  chooseTicket: "Elija el método de entrega de boletos", // translated
  ticketError: "Por favor seleccione un billete para todos los destinos", // translated
  ticketDelivery: "Por favor seleccione un método de entrega de boletos", // translated
  passengerDetails: "Detalles del pasajero", // translated
  waitWhileProcessingPayment: "Espere mientras procesamos su pago, no actualice ni cierre la página.", // translated
  reductionCardId: "ID de tarjeta de reducción", // translated
  countryOfResidence: "País de residencia", // translated
  countryOfBirth: "País de nacimiento", // translated
  documentCountry: "País del documento", // translated
  documentNumber: "Número del Documento", // translated
  expirationDate: "Fecha de caducidad", // translated
  documentType: "Tipo de Documento", // translated
  travelerDocumentInfo: "Información del documento de viajero", // translated
  youth: "Juventud", // translated
  youths: "jóvenes", // translated
  departTimeEarlyFirst: "Hora de salida (primero primero)", // translated
};

export default trains;
